"use strict";

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _require = require("../helpers/events"),
    fireAnEvent = _require.fireAnEvent;

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var HTMLDetailsElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLDetailsElementImpl, _HTMLElementImpl);

  function HTMLDetailsElementImpl(globalObject, args, privateData) {
    var _this;

    _classCallCheck(this, HTMLDetailsElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLDetailsElementImpl).call(this, globalObject, args, privateData));
    _this._taskQueue = null;
    return _this;
  }

  _createClass(HTMLDetailsElementImpl, [{
    key: "_dispatchToggleEvent",
    value: function _dispatchToggleEvent() {
      this._taskQueue = null;
      fireAnEvent("toggle", this);
    }
  }, {
    key: "_attrModified",
    value: function _attrModified(name, value, oldValue) {
      _get(_getPrototypeOf(HTMLDetailsElementImpl.prototype), "_attrModified", this).call(this, name, value, oldValue);

      if (name === "open" && this._taskQueue === null) {
        // Check that the attribute is added or removed, not merely changed
        if (value !== oldValue && value !== null && oldValue === null || value === null && oldValue !== null) {
          this._taskQueue = setTimeout(this._dispatchToggleEvent.bind(this), 0);
        }
      }
    }
  }]);

  return HTMLDetailsElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLDetailsElementImpl
};